import { SelectFields } from '@repo/toolkit/types'

import { Guide } from '../../models/guide/guide'
import { FieldsSelector } from '../../utils'

export const enrollmentGuideFields = ['id', 'pdf.path'] as const satisfies FieldsSelector<Guide>

export type EnrollmentGuideType = SelectFields<Guide, typeof enrollmentGuideFields>
